<template>
  <a-modal
    :title="title"
    width="50%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
      >
        <div class="form-row">
          <div class="form-item">
            <a-form-model-item label="姓名" prop="teacherName">
              <a-input v-model="form.teacherName" :disabled="disabeld" />
            </a-form-model-item>
          </div>
          <div class="form-item">
            <a-form-model-item label="性别" prop="sex">
              <a-radio-group v-model="form.sex" :disabled="disabeld">
                <a-radio value="男">男</a-radio>
                <a-radio value="女">女</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </div>
        </div>

        <div class="form-row">
          <div class="form-item">
            <a-form-model-item
              label="学历"
              :label-col="labelCol"
              prop="education"
            >
              <a-select v-model="form.education" :disabled="disabeld">
                <a-select-option
                  :value="item.title"
                  v-for="(item, index) in xwlist"
                  :key="index"
                  >{{ item.title }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <div class="form-item">
            <a-form-model-item
              label="职称"
              prop="professionalTitle"
              :label-col="labelCol"
            >
              <a-select v-model="form.professionalTitle" :disabled="disabeld">
                <a-select-option
                  :value="item.title"
                  v-for="(item, index) in zclist"
                  :key="index"
                  >{{ item.title }}</a-select-option
                >
              </a-select>
              <!--<a-input v-model="form.professionalTitle" />-->
            </a-form-model-item>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <a-form-model-item label="从事内容" prop="engagedContent">
              <a-select v-model="form.engagedContent" :disabled="disabeld">
                <a-select-option
                  :value="item.title"
                  v-for="(item, index) in contentlist"
                  :key="index"
                  >{{ item.title }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <div class="form-item">
            <a-form-model-item label="加入年份" prop="joinYear">
              <a-date-picker
                :disabled="disabeld"
                style="width: 100%"
                placeholder="请选择加入年份"
                v-model="form.joinYear"
                :open="yearShowOne"
                :locale="locale"
                :format="'YYYY'"
                mode="year"
                @openChange="openChangeOne"
                @panelChange="panelChangeOne"
                @change="handleClearAcquireYear"
              />
            </a-form-model-item>
          </div>
        </div>
        <a-form-model-item label="所属部门" prop="departCode">
          <a-input v-model="form.departCode" :disabled="disabeld" />
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="phone">
          <a-input
            type="text"
            :maxLength="11"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入联系电话"
            v-model="form.phone"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="主要任务">
          <div class="flex align-items-end">
            <a-textarea
              v-model="form.primaryMission"
              placeholder="请输入主要任务"
              :disabled="disabeld"
              :auto-size="{ minRows: 4, maxRows: 6 }"
            />
            <span class="primaryMisssonLabel">200字</span>
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item label="生日" prop="birthday">
               <a-date-picker v-model="form.birthday"  :locale="locale"/>
          </a-form-model-item> -->
        <!-- <a-form-model-item label="从事专业" >
            <a-input v-model="form.major" />
          </a-form-model-item> -->
        <!-- <a-form-model-item label="是否思政老师" prop="izPolitical">
						<a-select v-model="form.izPolitical" >
							<a-select-option value="1">是</a-select-option>
		        <a-select-option value="0">否</a-select-option>	
						</a-select>
          </a-form-model-item> -->
        <a-form-model-item label="是否负责人" prop="izResponse">
          <a-radio-group v-model="form.izResponse" :disabled="disabeld">
            <a-radio value="是">是</a-radio>
            <a-radio value="否">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- <a-form-model-item label="成员来源" prop="memberSource">
						<a-select v-model="form.memberSource" >
							<a-select-option :value="item.value" v-for="item in cylist">{{item.title}}</a-select-option>
						</a-select>
					</a-form-model-item> -->
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { style: { width: "100px" } },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        teacherName: "",
        sex: 1,
        // birthday:'',
        education: "",
        professionalTitle: "",
        major: "",
        primaryMission: "",
        izPolitical: "",
        joinYear: new Date().getFullYear(),
        izResponse: "否",
        memberSource: "",
        engagedContent: "",
        phone: "",
        departCode: "",
      },
      disabeld: false,
      rules: {
        teacherName: [
          {
            required: true,
            message: "请输入教师姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择教师性别",
            trigger: "change",
          },
        ],
        // birthday: [
        //   {
        //     required: true,
        //     message: "请选择教师生日",
        //     trigger: "change",
        //   },
        // ],
        education: [
          {
            required: true,
            message: "请输入教师学历",
            trigger: "change",
          },
        ],
        professionalTitle: [
          {
            required: true,
            message: "请选择教师职称",
            trigger: "blur",
          },
        ],
        engagedContent: [
          {
            required: true,
            message: "请选择从事内容",
            trigger: "blur",
          },
        ],
        joinYear: [
          {
            validator: (rule, value, callback) => {
              console.log(value, this.form.joinYear);
              if (this.form.joinYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择加入年份"));
              }
            },
            required: true,
            message: "请选择加入年份",
            trigger: "change",
          },
        ],
        primaryMission: [
          // {
          //   required: true,
          //   message: "请输入主要任务",
          //   trigger: "blur",
          // },
          {
            max: 200,
            message: "内容字数不能超过200",
            trigger: "blur",
          },
        ],
        izPolitical: [
          {
            required: true,
            message: "请选择是否是思政老师",
            trigger: "change",
          },
        ],
        izResponse: [
          {
            required: true,
            message: "请选择是否是负责人",
            trigger: "change",
          },
        ],
        // memberSource: [
        //   {
        //     required: true,
        //     message: "请选择成员来源",
        //     trigger: "change",
        //   },
        // ],
      },
      sexlist: [],
      sjlist: [],
      zclist: [],
      cylist: [],
      zh_CN,
      locale,
      applyType: 1,
      yearShowOne: false,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      contentlist: [],
    };
  },
  methods: {
    init(type, record) {
      console.log("record", record);
      this.type = type;
      this.visible = true;
      this.getxwlist();
      this.getzclist();
      this.getcsnrlist();
      this.disabeld = false;
      // this.getcylist();
      if (type == "add") {
        this.form = { izResponse: "否" };
        this.form.applyId = record.id;
        this.form.joinYear = new Date().getFullYear() + "";
        this.form.sex = 1;
        this.title = "添加老师";
      } else if (type == "edit") {
        this.title = "编辑老师";
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          //birthday: record.birthday,
          education: record.education,
          professionalTitle: record.professionalTitle,
          major: record.major,
          primaryMission: record.primaryMission,
          izResponse: record.izResponse, // 返回是 否
          applyId: record.applyId,
          id: record.id,
          izPolitical: record.izPolitical,
          joinYear: record.joinYear,
          education: record.education,
          // memberSource: record.memberSource,
          engagedContent: record.engagedContent,
          phone: record.phone,
          departCode: record.departCode,
        };
      } else {
        this.disabeld = true;
        this.title = "查看老师";
        console.log(record);
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          //birthday: record.birthday,
          degree: record.degree,
          professionalTitle: record.professionalTitle,
          major: record.major,
          primaryMission: record.primaryMission,
          izResponse: record.izResponse,
          applyId: record.applyId,
          id: record.id,
          izPolitical: record.izPolitical,
          joinYear: record.joinYear,
          education: record.education,
          // memberSource: record.memberSource,
          engagedContent: record.engagedContent,
        };
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.joinYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      console.log(value._d, "111111");
      const date = new Date(value._d + "");
      const year = moment(value).format("YYYY");
      this.form.joinYear = year + "";
      console.log(this.form.joinYear);
      //  if (
      //   typeof this.form.joinYear == "object" &&
      //   this.form.joinYear != ""
      //   ) {
      //     this.form.joinYear = new Date(this.form.joinYear).getFullYear()+"";
      //   }
      this.yearShowOne = false;
      this.$refs.ruleForm.validateField("joinYear");
      // this.$refs.ruleForm.clearValidate("joinYear");
    },
    getcsnrlist() {
      getAction("/baseCommon/getDictItemsByCode?code=engaged_content", {}).then(
        (res) => {
          if (res.code == 200) {
            console.log(res);
            this.contentlist = res.result;
          }
        }
      );
    },
    getcylist() {
      getAction("/baseCommon/getDictItemsByCode?code=member_source", {}).then(
        (res) => {
          if (res.code == 200) {
            console.log(res);
            this.cylist = res.result;
          }
        }
      );
    },
    getsjlist() {
      getAction("/baseCommon/getDictItemsByCode?code=yn", {}).then((res) => {
        if (res.code == 200) {
          //              console.log(res);
          this.sjlist = res.result;
        }
      });
    },
    getzclist() {
      getAction("/baseCommon/getDictItemsByCode?code=professional", {}).then(
        (res) => {
          if (res.code == 200) {
            // console.log(res);
            this.zclist = res.result;
          }
        }
      );
    },
    getxwlist() {
      getAction("/baseCommon/getDictItemsByCode?code=education", {}).then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getsexlist() {
      getAction("/baseCommon/getDictItemsByCode?code=sex", {}).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.sexlist = res.result;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      console.log("11111", this.type);
      if (this.disabeld) {
        this.visible = false;
        return false;
      }
      console.log(typeof this.form.joinYear, "想要的");
      if (
        typeof this.form.joinYear == "object" &&
        this.form.joinYear != "" &&
        this.type == "add"
      ) {
        this.form.joinYear = new Date(this.form.joinYear).getFullYear() + "";
        this.form.joinYear = this.form.joinYear.toString();
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // const dateObj = new Date(this.form.birthday);
          // const year = dateObj.getFullYear();
          // const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
          // const date = dateObj.getDate();
          // const formattedDate = `${year}-${month
          //   .toString()
          //   .padStart(2, "0")}-${date.toString().padStart(2, "0")}`;
          if (this.type == "add") {
            let params = this.form;

            params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("addTeacher", { record: params, type: "add" });
          } else {
            let params = this.form;
            params.applyType = this.applyType;
            if (typeof this.form.joinYear == "object") {
              params.joinYear = new Date(this.form.joinYear).getFullYear() + "";
            }
            //params.birthday = formattedDate;
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addTeacher", { record: params, type: "edit" });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
/deep/ .ant-form-item {
  display: flex;
}
/deep/ .ant-form-item-control-wrapper {
  // width: 120px;
  flex: 1;
}
.form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    width: 50%;
  }
}
.primaryMisssonLabel {
  display: inline-block;
  width: 60px;
  line-height: normal;
  margin-left: 12px;
}
</style>
  